.bar {
  flex: none; /* prevent shrinking when metadata viewer scrolls */
  display: flex;
  justify-content: space-between;
  height: var(--toolbar-height);
  padding: 0 0.5rem;
  background-color: var(--secondary-bg);
  font-size: 0.875rem;
}

.sep {
  margin-left: 0.375rem;
  margin-right: 0.375rem;
}

.breadCrumbs {
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
  min-width: 0;
  margin: 0;
  padding: 0 0.5rem;
  font-size: inherit;
  font-weight: inherit;
  line-height: 1.3; /* fix cropping of glyphs */
  white-space: nowrap;
}

.crumbButton {
  composes: btnClean from '../utils.module.css';
  position: relative;
  display: flex;
  align-items: center;
  min-width: 0;
}

.crumbButton[data-current] {
  flex: none; /* never shrink current breadcrumb */
  font-weight: 600;
  padding-right: 1rem;
}

.crumbButton:hover {
  text-decoration: underline;
}

.crumb {
  margin: 0 0.125rem 0.125rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.separator {
  flex: none;
  min-width: 0.75rem;
}

.copyIcon {
  position: absolute;
  font-size: 0.9rem;
  top: calc(50% - 0.125rem);
  right: 0.875rem;
  margin: 2px 0 1px 0;
  transform: translate(100%, -50%);
}

.crumbButton:not(:hover, :focus-visible, [data-copied]) > .copyIcon {
  display: none;
}
